<template>
	<VCardWrapper :condition="this?.$vuetify.breakpoint.smAndDown" class="media-card">
		<v-card-text>
			<div class="d-flex mt-2 video-title">
				<div class="d-flex page media-header">
					<v-icon>{{ icon }}</v-icon>
					<div class="heading">{{ title }} ({{ count }})</div>
				</div>
				<div v-if="count > 0">
					<v-btn class="white--text view-button" color="primary" elevation="0" @click="handleViewAll">
						{{ viewButtonText }}
					</v-btn>
				</div>
			</div>
			<slot></slot>
		</v-card-text>
	</VCardWrapper>
</template>

<script>
	import VCardWrapper from "../VCardWrapper.vue";
	export default {
		components: {
			VCardWrapper,
		},
		props: {
			icon: String,
			title: String,
			count: Number,
			artifactType: String,
		},
		computed: {
			viewButtonText() {
				return this.count === 1 ? "View" : "View All";
			},
		},
		methods: {
			handleViewAll() {
				this.$emit("view-all", this.artifactType);
			},
		},
	};
</script>

<style scoped>
	.media-header .v-icon {
		width: 28px;
		height: 28px;
		color: #0070ff;
		margin-right: 8px;
		padding: 6px;
	}
	@media (max-width: 959px) {
		.media-card {
			padding: 0;
		}

		.media-card .v-card__text {
			padding-left: 1rem !important;
			padding-right: 1rem !important;
		}

		.media-card .v-card__text.no-snapshots {
			padding: 20px;
		}
		:deep(.media-card .v-card__text.pad-equal) {
			padding: 0px 16px !important;
		}
	}
	.media-card {
		margin-bottom: 1rem;
		min-height: unset !important;
		border-radius: 15px !important;
	}
	.media-card .v-card__text {
		padding-left: 0rem;
		padding-right: 0rem;
	}
	.video-title {
		justify-content: space-between;
	}

	.media-header {
		align-items: center;
		margin-bottom: 16px;
		color: #03011d;
	}

	.media-header.v-icon {
		width: 28px;
		height: 28px;
		color: #0070ff;
		margin-right: 8px;
		padding: 6px;
	}

	.media-header .heading {
		font-family: "Inter Tight", sans-serif;
		font-size: 1.25rem;
		font-style: normal;
		font-weight: 600;
		line-height: 1.2;
		margin-right: 4px;
	}

	.view-button {
		height: 22px !important;
		width: 61px !important;
		font-size: 12px !important;
		border-radius: 8px;
	}
</style>
